module.exports = __webpack_public_path__ + "static/media/thumb-up-svgrepo-com (5).5480f011.svg";